var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.846,
    height: 86.24,
    viewBox: "0 0 104.846 86.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(-290.573 -275.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M191.7,225.338c.791,19.059,25.727,26.713,47.611,23.21,12.3-1.962,23.641-7.449,29.189-16.419a23.533,23.533,0,0,0,3.473-10.377C275.25,186.213,189.192,164.719,191.7,225.338Z",
    transform: "translate(159.936 50.097) rotate(13)",
    fill: "#003361",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M272.01,225.338c-.791,19.059-25.727,26.713-47.611,23.21-12.3-1.962-23.641-7.449-29.189-16.418a23.533,23.533,0,0,1-3.473-10.377C188.459,186.213,274.517,164.719,272.01,225.338Z",
    transform: "translate(123.355 112.458)",
    fill: "#fff",
    opacity: 0.287
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hands-helping",
    "data-name": "Icon awesome-hands-helping",
    d: "M21.816,8.584h-6.8v2.5a3.219,3.219,0,0,1-6.438,0V5.652L5.682,7.4a2.855,2.855,0,0,0-1.39,2.45V11.96L.715,14.025a1.427,1.427,0,0,0-.523,1.954l3.577,6.2a1.431,1.431,0,0,0,1.954.523l4.623-2.669h6.107a2.864,2.864,0,0,0,2.861-2.861h.715a1.429,1.429,0,0,0,1.431-1.431V12.876h.358A1.07,1.07,0,0,0,22.889,11.8V9.657A1.07,1.07,0,0,0,21.816,8.584Zm6.6-1.672L24.843.716A1.431,1.431,0,0,0,22.889.193L18.267,2.862H13.7a2.883,2.883,0,0,0-1.516.434l-1.5.934a1.421,1.421,0,0,0-.671,1.212v5.646a1.788,1.788,0,0,0,3.577,0V7.154h8.226a2.505,2.505,0,0,1,2.5,2.5v1.274L27.9,8.866a1.432,1.432,0,0,0,.523-1.954Z",
    transform: "translate(333.599 314.063)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/help-support.9a3aa69f8f5dae68c670f601752e4b26.svg";
export { ForwardRef as ReactComponent };